export default __webpack_public_path__ + "static/media/admin-bg-sm.af07a068.svg";